import { createQuery } from '@amzn/gsce-shared-react-lib';
import {
  ListRiskScoresCommand,
  type ListRiskScoresCommandInput,
  type ListRiskScoresCommandOutput,
} from '@amzn/gbsa-helios-typescript-client';

import { apiHeliosClient, withRetry } from 'src/v2/shared/data';
import { RiskScoreQueryKeys } from './keys';

/**
 * Risk Engine scores for the business unit's live scoring day. One call returns the full result
 * set (bounded by the request's maxResults) plus totalCount — no pagination loop and no lazy
 * loading; the table renders exactly the rows the call returns.
 */
export const useListRiskScoresQuery = createQuery<
  ListRiskScoresCommandInput,
  ListRiskScoresCommandOutput
>(RiskScoreQueryKeys.lists, (input) =>
  withRetry(() => apiHeliosClient.send(new ListRiskScoresCommand(input))),
);
